module.exports = "https://bin.bnbstatic.com/_next/static/images/banner-bg-9b060b6007540e369f8a49dc773e305d.png";